import i18n from 'modules/core/lib/i18n'

import {
  type ExistingEmployeesByEmail,
  validateEmailForCreation,
} from 'modules/employees/lib/validateEmailForCreation'

type Props = {
  email: string
  existingEmployeesByEmail: ExistingEmployeesByEmail
}

const validateEmail = ({ email, existingEmployeesByEmail }: Props) => {
  const { valid, errorString } = validateEmailForCreation(email, existingEmployeesByEmail)

  return {
    isValid: valid,
    message: errorString ?? i18n.t('importer_process.edition_step.validators.email'),
  }
}

export default validateEmail
